// Basic modal setter
let basicModalSetter = () => {};

// Interactive modal setter
let interactiveModalSetter = () => {};

// Register basic modal setter
export const setBasicModalSetter = (setter) => {
    basicModalSetter = setter;
};

// Register interactive modal setter
export const setInteractiveModalSetter = (setter) => {
    interactiveModalSetter = setter;
};

// Open basic modal
export const openBasicModal = (config) => {
    if (!basicModalSetter) return;

    basicModalSetter({
        isOpen: true,
        success: config.success ?? false,
        message: config.message ?? '',
    });
};

// Open interactive modal
export const openInteractiveModal = (config) => {
    if (!interactiveModalSetter) return;

    interactiveModalSetter({
        isOpen: true,
        title: config.title ?? '',
        state: config.state ?? {},
        inputFields: config.inputFields ?? [],
        actionArray: config.actionArray ?? [],
    });
};

// Centralized error handler
export const handleError = (
    error,
    customMessage = 'An error occurred while processing your request.',
    success = false,
) => {
    let errorMessage;

    if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
    } else if (error?.message) {
        errorMessage = error.message;
    } else {
        errorMessage = customMessage;
    }

    openBasicModal({
        message: errorMessage,
        success,
    });
};
